import { ReactComponent as Icon } from './closeIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const CloseIcon: React.FC<Props> = ({
  ariaLabel = 'close',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'close-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
